import React from 'react';

export const ErrorIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg fill="none" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			clipRule="evenodd"
			d="M9 .667a1.864 1.864 0 0 0-1.32.547L1.214 7.681a1.866 1.866 0 0 0 0 2.639l6.468 6.468a1.866 1.866 0 0 0 2.638 0l6.469-6.469a1.866 1.866 0 0 0 0-2.638L10.32 1.214h-.001A1.864 1.864 0 0 0 9 .667Zm0 1.25a.614.614 0 0 0-.435.18L2.097 8.566a.617.617 0 0 0 0 .871l6.468 6.467a.616.616 0 0 0 .87 0l6.468-6.467a.616.616 0 0 0 0-.871L9.435 2.097A.614.614 0 0 0 9 1.917Z"
			fill="#BA1309"
			fillRule="evenodd"
		/>
		<path
			d="M10.042 12.333a1.042 1.042 0 1 1-2.084 0 1.042 1.042 0 0 1 2.084 0Zm-1.75-6.791a.708.708 0 1 1 1.416 0v4a.708.708 0 0 1-1.416 0v-4Z"
			fill="#BA1309"
		/>
	</svg>
);
